import _uniqBy from 'lodash.uniqby'
import moment from 'moment'

import { USER_STATES } from 'constants/index'
import * as types from '../types/assignedUsers'
import pools from 'api/pools'

const fetchSuccess = (users) => ({
  type: types.FETCH_ASSIGNED_USERS_SUCCESS,
  users
})

export const fetchAssignedUsersSuccess = (users) => (dispatch, getState) => {
  const { user: { _id, frontOptions }, tabs } = getState()

  const channelsFilter = Array.isArray(frontOptions?.channelsAssigned) ? frontOptions?.channelsAssigned?.map(c => c.value.split('_')[0]) : []
  const typeFilter = frontOptions?.selectTypeAssigned?.value
  const isAsc = frontOptions?.orderAssigned?.value === 'asc' || frontOptions?.orderAssigned === 'asc'

  const {
    outboundAssigned: isOutbound,
    switchPendingAssigned: isPendingMsg,
    checkedOnlyToMeAssigned: onlyAssignedToMe,
    brandsAndDelegationsAssigned,
    categoriesAssigned = []
  } = frontOptions || {}

  const delegations = (brandsAndDelegationsAssigned?.delegations || []).map(d => d.value || d)
  const delegationSize = delegations.length
  const withoutCategory = categoriesAssigned.some(elem => elem === 'label_without_category')
  const categorySize = withoutCategory ? categoriesAssigned.length - 1 : categoriesAssigned.length

  dispatch(fetchSuccess(
    _uniqBy(users, 'id').filter(user => {
      const {
        id, state, notInPool, pendingMsgCount, isRead, assignedTo = [], outboundAt,
        drafts, lastMsgType, channels = [], delegation, channelRemove, categories = []
      } = user

      if (channelRemove) return false
      if (!assignedTo.includes(_id)) return false
      if (USER_STATES.isNotPool.includes(state)) return false
      if (notInPool) return false
      if (delegationSize && !delegations.includes(delegation)) return false

      // Unread filter
      const withPendingMsg = pendingMsgCount > 0 || !isRead
      if (isPendingMsg && !withPendingMsg) return false

      // Assigned to me filter
      const onlyMe = assignedTo.length === 1
      if (onlyAssignedToMe && !onlyMe) return false

      // Outbound filter
      if (isOutbound && !outboundAt) return false

      // Type filter
      if (typeFilter) {
        if (typeFilter === 'draft' && !drafts) return false
        if (typeFilter === 'sent' && !lastMsgType.includes('operator')) return false
        if (typeFilter === 'received' && !lastMsgType.includes('customer')) return false
        if (typeFilter === 'openedTabs' && !tabs.users?.some(e => e.id === id)) return false
      }

      // Channels filter
      if (channelsFilter?.length) {
        const channel = channels[0] || {}

        if (channel.provider === 'chatmail') {
          if (!channelsFilter.includes(channel.provider)) return false
        } else if (channel.channel === 'wall') {
          if (!channelsFilter.includes(channel.connectionType.split('_')[0])) return false
        } else {
          if (!channelsFilter.includes(channel.channel)) return false
        }
      }

      if (!withoutCategory && categorySize) {
        if (!categoriesAssigned.some(cat => categories.includes(cat))) return false
      }

      if (withoutCategory && !categorySize) {
        if (categories?.length) return false
      }

      if (categorySize && withoutCategory) {
        const userCategoriesSize = categories?.length

        if (userCategoriesSize) {
          if (!categoriesAssigned.some(cat => categories.includes(cat))) return false
        }
      }

      return true
    }).sort((a, b) => {
      return isAsc
        ? moment(a.lastMessageSentAt || a.updatedAt) - moment(b.lastMessageSentAt || b.updatedAt)
        : moment(b.lastMessageSentAt || b.updatedAt) - moment(a.lastMessageSentAt || a.updatedAt)
    })
  ))
}

export const fetchAssignedUsersFailure = (error) => ({
  type: types.FETCH_ASSIGNED_USERS_FAILURE,
  error,
})

export const fetchAssignedUsers = (params) => async (dispatch, getState) => {
  const {
    order,
    withPendingMsg,
    onlyAssignedToMe,
    outbound,
    selectType,
    channels,
    brands,
    delegations,
    categories
  } = params

  const { tabs } = getState()

  const data = {
    order,
    withPendingMsg,
    onlyAssignedToMe,
    outbound
  }

  /* TYPE FILTER */
  const initialSelectType = selectType?.value
  if (!['all', 'openedTabs'].includes(initialSelectType)) {
    data.selectType = initialSelectType
  } else {
    data.selectType = ''
  }
  /* CHANNELS FILTER */
  if (channels?.length) {
    data.channels = channels.map(channel => channel.value)
  } else {
    data.channels = []
  }
  /* BRANDS AND DELEGATIONS FILTER */
  // Brands
  if (brands?.length) {
    data.brands = brands.map(brand => brand.value)
  } else {
    data.brands = []
  }
  // Delegations
  if (delegations?.length) {
    data.delegations = delegations.map(delegation => delegation.value)
  } else {
    data.delegations = []
  }

  if (categories?.length) {
    data.withoutCategory = categories.some(elem => elem === 'label_without_category')
    data.categories = categories.filter(elem => elem !== 'label_without_category')
  }

  return pools.assignedUsers(data)
    .then(({ data, status }) => {
      if (status === 200) {
        let users = [...data.users]

        if (initialSelectType === 'openedTabs') {
          const openedUsers = []
          for (const openedUserId of tabs.users) {
            const openedUser = users.find(user => user.id === openedUserId)
            if (openedUser) openedUsers.push(openedUser)
          }
          users = [...openedUsers]
        }

        dispatch(fetchSuccess(users))
      }
    })
    .catch((err) => dispatch(fetchAssignedUsersFailure(err)))
}
